import { atom, useRecoilState } from "recoil";

interface BulkEquipmentUploadState {
    showBanner: boolean;
    batchId: string | null;
    total: number;
    completed: number;
    failed: number;
    status: "processing" | "completed";
}

export const DEFAULT_BULK_EQUIPMENT_UPLOAD_STATE: BulkEquipmentUploadState = {
    showBanner: false,
    batchId: null,
    total: 0,
    completed: 0,
    failed: 0,
    status: "processing",
};

const bulkEquipmentUploadStateAtom = atom<BulkEquipmentUploadState>({
    key: "bulkEquipmentUploadState",
    default: DEFAULT_BULK_EQUIPMENT_UPLOAD_STATE,
});

const useBulkEquipmentUploadState = () => {
    const [state, setState] = useRecoilState(bulkEquipmentUploadStateAtom);

    const resetStateToDefault = () => {
        setState(DEFAULT_BULK_EQUIPMENT_UPLOAD_STATE);
    };

    return {
        state,
        setState,
        resetStateToDefault,
    };
};

export default useBulkEquipmentUploadState;
